import { IComposition } from "common/interfaces/IComposition";

export class RateLibraryTasks {
  class: string;
  code: string;
  composition: Array<IComposition>;
  description: string;
  descriptionGroup: string;
  alternativeCodeComposition: string;
  alternativeCodeItem: string;
  equipmentCost: Number;
  equipmentCostPecentage: Number;
  laborCost: Number;
  laborCostPercenage: Number;
  level: { id: string; reference: string };
  link: string;
  materialCost: Number;
  materialCostPercentage: Number;
  otherCost: Number;
  otherCostPercentage: Number;
  priceRise: string;
  thirdPartyServiceCost: Number;
  thirdPartyServiceCostPercentage: Number;
  totalCost: Number;
  type: "RESOURCE" | "TASK";
  unity: string;
  file: { id: string };
  compositionList: Array<string>;

  constructor(
    classe: string,
    code: string,
    composition: Array<IComposition>,
    description: string,
    descriptionGroup: string,
    alternativeCodeComposition: string,
    alternativeCodeItem: string,
    equipmentCost: Number,
    equipmentCostPecentage: Number,
    laborCost: Number,
    laborCostPercenage: Number,
    level: { id: string; reference: string },
    link: string,
    materialCost: Number,
    materialCostPercentage: Number,
    otherCost: Number,
    otherCostPercentage: Number,
    priceRise: string,
    thirdPartyServiceCost: Number,
    thirdPartyServiceCostPercentage: Number,
    totalCost: Number,
    type: "RESOURCE" | "TASK",
    unity: string,
    file: { id: string },
    compositionList: Array<string>
  ) {
    this.class = classe;
    this.code = code;
    this.composition = composition;
    this.description = description;
    this.descriptionGroup = descriptionGroup;
    this.alternativeCodeComposition = alternativeCodeComposition;
    this.alternativeCodeItem = alternativeCodeItem;
    this.equipmentCost = equipmentCost;
    this.equipmentCostPecentage = equipmentCostPecentage;
    this.laborCost = laborCost;
    this.laborCostPercenage = laborCostPercenage;
    this.level = level;
    this.link = link;
    this.materialCost = materialCost;
    this.materialCostPercentage = materialCostPercentage;
    this.otherCost = otherCost;
    this.otherCostPercentage = otherCostPercentage;
    this.priceRise = priceRise;
    this.thirdPartyServiceCost = thirdPartyServiceCost;
    this.thirdPartyServiceCostPercentage = thirdPartyServiceCostPercentage;
    this.totalCost = totalCost;
    this.type = type;
    this.unity = unity;
    this.file = file;
    this.compositionList = compositionList;
  }
}



// WEBPACK FOOTER //
// ./src/modules/activitySearch/models/RateLibraryTasks.tsx